import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rows-container" }
const _hoisted_2 = { class: "list-unstyled mb-0" }
const _hoisted_3 = { class: "object-row d-flex align-items-center" }
const _hoisted_4 = { class: "bt-icon bt-icon--m" }
const _hoisted_5 = { class: "ml-3" }
const _hoisted_6 = { class: "bt-icon bt-icon--xs" }
const _hoisted_7 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogAddAction = _resolveComponent("DialogAddAction")
  const _component_DialogAddTriggerAndCondition = _resolveComponent("DialogAddTriggerAndCondition")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("ul", _hoisted_2, [
            _createVNode("li", _hoisted_3, [
              _createVNode("span", _hoisted_4, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                    require(`@/assets/images/icons/icon-datetime.svg`)
                                ,
                  "aria-label": "icon-datetime"
                }, null, 8, ["src"])
              ]),
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.name), 1),
              _createVNode(_component_Button, {
                class: "ml-auto p-button-rounded p-button-outlined",
                onClick: _ctx.openShowDialogAction
              }, {
                default: _withCtx(() => [
                  _createVNode("span", _hoisted_6, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: 
                                        require(`@/assets/images/icons/icon-plus-outline.svg`)
                                    ,
                      "aria-label": "icon-grid"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_DialogAddAction, {
      "is-visible": _ctx.isVisibleDialogAddObject,
      "onUpdate:is-visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisibleDialogAddObject = $event)),
      onConfirm: _ctx.handleDoAddObject,
      actionToAdd: _ctx.tempToAdd
    }, null, 8, ["is-visible", "onConfirm", "actionToAdd"]),
    _createVNode(_component_DialogAddTriggerAndCondition, {
      "is-visible": _ctx.isVisibleDialogTrigger,
      "onUpdate:is-visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isVisibleDialogTrigger = $event)),
      onConfirm: _ctx.handleDoAddTrigger,
      triggerOrActionToAdd: _ctx.tempToAdd,
      "step-to-add": _ctx.stepToAdd,
      triggerOrConditionType: _ctx.SceneObjectType.DateTime,
      triggerOrConditionName: _ctx.name
    }, null, 8, ["is-visible", "onConfirm", "triggerOrActionToAdd", "step-to-add", "triggerOrConditionType", "triggerOrConditionName"])
  ], 64))
}